import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import RoleSelection from "./screens/auth/RoleSelection";
import Login from "./screens/auth/Login";
import UserLayout from "./layouts/UserLayout";
import AdminLayout from "./layouts/AdminLayout";
import LibrarianLayout from "./layouts/LibrarianLayout";
import PublicLayout from "./layouts/PublicLayout";
import Signup from "./screens/auth/Signup";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
  
    <BrowserRouter>
      <Routes>
      <Route path="/*" element={<PublicLayout/>}/>
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />


        {/* AUTH */}
       <Route
  path="/user/*"
  element={
    <ProtectedRoute role="user">
      <UserLayout />
    </ProtectedRoute>
  }
/>

<Route
  path="/librarian/*"
  element={
    <ProtectedRoute role="librarian">
      <LibrarianLayout />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/*"
  element={
    <ProtectedRoute role="admin">
      <AdminLayout />
    </ProtectedRoute>
  }
/>

      </Routes>
    </BrowserRouter>
  );
}

export default App;